export function sessionId() {
  let id = localStorage.getItem("lint_session");
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem("lint_session", id);
  }
  return id;
}
